import { Injectable } from "@angular/core";

import { AppState } from "../../core/app-state";

import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { RestClient } from "../../core/services/rest-client";
import {
  FesRutTaskConfig,
  VolunteerTaskRecord,
  VolunteerTaskViewRecord,
} from "../models";

@Injectable({ providedIn: "root" })
export class VolunteerTaskService extends RestClient<VolunteerTaskRecord> {

  cachedConfig: FesRutTaskConfig;


  constructor(
    public appState: AppState,
    http: HttpClient,    
  ) {
    super(http, "volunteerTask", appState);
  }


  async getRemoteConfig(): Promise<FesRutTaskConfig> {
    if ( !this.cachedConfig ) {
      this.cachedConfig = await firstValueFrom(this.http.get(`${this.urlPath}/config`)) as FesRutTaskConfig;
    }
    return this.cachedConfig;
  }


  async patch(fields: Partial<VolunteerTaskRecord>) {
    try {
      const result: any = await firstValueFrom(
        this.http.patch<Partial<VolunteerTaskRecord>>(
          `${this.urlPath}/patch`,
          fields,
          { observe: "response" }
        )
      );
      const resp: VolunteerTaskViewRecord = result.body;
      return resp;
    } catch (error) {
      console.error("patch() error: " + error?.message);
      throw error;
    }
  }

  async save(rec: VolunteerTaskRecord) {
    const result: any = await firstValueFrom(
      this.http.put<VolunteerTaskRecord>(`${this.urlPath}/save`, rec, {
        observe: "response",
      })
    );
    const savedRec: VolunteerTaskRecord = result.body;
    console.log(JSON.stringify(savedRec));
    return savedRec;
  }

  async deleteTaskById(volunteerTaskId: number): Promise<VolunteerTaskRecord> {
    console.log('Deleting volunteer task.  ID="' + volunteerTaskId + '"');
    if (!volunteerTaskId) {
      throw new Error("No ID set for delete volunteer task.");
    }
    const resp = await firstValueFrom(
      this.http.delete<VolunteerTaskRecord>(
        this.urlPath + "/" + volunteerTaskId,
        { observe: "response" }
      )
    );
    console.dir(resp);
    const deletedTask = resp.body;
    return deletedTask;
  }

}
